import { GeneratePublicToken } from "../utils/GeneratePublicToken";
import axios from "axios";
import Cookies from "js-cookie";

const token = () => Cookies.get("accessTokenOfficeOlin");

export const getRankPrinciple = async (offset, limit) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}get/principal/rank?offset=${offset}&limit=${limit}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getPrincipalPbf = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/principals`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail.data;
  } catch (err) {
    throw err;
  }
};

export const getLabelPurchase = async (offset, limit, name) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}get/label?offset=${offset}&limit=${limit}&name=${name}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getPrincipal = async (offset, limit, name) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}get/principal?offset=${offset}&limit=${limit}&name=${name}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const fetchAllProducts = async ({ offset, limit }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}products`,
      method: "POST",
      data: {
        offset,
        limit,
      },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getMostSearchedProduct = async (limit, offset) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}most/product?offset=${offset}&limit=${limit}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getProductBasedOnSearch = async (offset, limit) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}get/product/search?offset=${offset}&limit=${limit}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const fetchCategoriesProduct = async ({
  offset,
  limit,
  category_name,
}) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}category`,
      method: "POST",
      data: {
        offset,
        limit,
        category_name,
      },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const fetchSpecialOffer = async ({ offset, limit }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}product/so`,
      method: "POST",
      data: {
        offset,
        limit,
      },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const fetchSpecialOfferBackground = async ({ offset, limit }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}product/so/homepage-v2`,
      method: "POST",
      data: {
        offset,
        limit,
      },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const addToCartPurchase = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}add/cart/purchase-v2`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const addToCartPurchasePbf = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/cart/add`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};


export const updateCartPurchase = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/cart/update`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getCountCart = async (tipe) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}count/cart?tipe=${tipe}`,
      method: "GET",
      // url: `${process.env.REACT_APP_API_PURCHASE}count/cart-v2`,
      // method: "POST",
      // data: { tipe: tipe, is_sfa: false }
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getProductByPrincipalId = async (id, limit, offset) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}get/product/principal?id=${id}&limit=${limit}&offset=${offset}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getProductByCategoryId = async (id, limit, pageParam = 1) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}get/product/category?id=${id}&limit=${limit}&offset=${pageParam}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getProductDetailPurchase = async (id, type) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      // url: `${process.env.REACT_APP_API_PURCHASE}product/detail?product_id=${product_id}&type=${type}`,
      // method: "GET",
      url: `${process.env.REACT_APP_API_PURCHASE}product/detail-v2`,
      // url: `${process.env.REACT_APP_API_PBF}pbf/products/detail`,
      method: "POST",
      data: { product_id: id, type: type, is_sfa: false }
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getProductDetailPurchasePbf = async (slug) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      // url: `${process.env.REACT_APP_API_PURCHASE}product/detail?product_id=${product_id}&type=${type}`,
      // method: "GET",
      // url: `${process.env.REACT_APP_API_PURCHASE}product/detail-v2`,
      url: `${process.env.REACT_APP_API_PBF}pbf/products/detail`,
      method: "POST",
      data: { slug: slug }
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getHistorySearch = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      // url: `${process.env.REACT_APP_API_PURCHASE}get/history/search`,
      url: `${process.env.REACT_APP_API_PBF}pbf/products/search/history`,
      method: "POST",
      data: {},
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const searchProduct = async ({ search, offset, limit }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}search/product`,
      method: "POST",
      data: { search, offset, limit },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const searchProductBy = async ({ search, offset, limit, type, id }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}search/product/by`,
      method: "POST",
      data: { search, offset, limit, type, id },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const deleteHistorySearch = async (id) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      // url: `${process.env.REACT_APP_API_PURCHASE}delete/history/search`,
      url: `${process.env.REACT_APP_API_PBF}pbf/products/search/history/clear`,
      method: "POST",
      data: { id: Number(id) }
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const deleteSingleHistorySearch = async (id) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}delete/history/search?id=${id}`,
      method: "DELETE",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getCartDetails = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      // url: `${process.env.REACT_APP_API_PURCHASE}carts-new`,
      method: "POST",
      url: `${process.env.REACT_APP_API_PURCHASE}carts-v2`,
      data: { is_sfa: false }
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getCartDetailsPbf = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/cart/get`,
      method: "POST",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getVoucher = async (code, limit, offset) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}voucher?code=${code}&limit=${limit}&offset=${offset}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getVoucherPbf = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/voucher/list`,
      method: "POST",
      data: {}
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const fetchDetailVoucher = async (voucher_id) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}voucher/detail`,
      method: "POST",
      data: { voucher_id },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const checkallCartProduct = async (checklist) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      // url: `${process.env.REACT_APP_API_PURCHASE}update/cart/checklist-v2`,
      url: `${process.env.REACT_APP_API_PBF}pbf/cart/check/all`,
      method: "POST",
      data: { is_checked: checklist },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getPaymentMethod = async () => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];

  try {
    const config = {
      headers: {
        Authorization: TokenAuth,
        "Authorization-ID": TokenAuthID,
      },
      url: `${process.env.REACT_APP_API_MASTER}payment-method`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getPaymentMethodNew = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}payment-method-new?is_subscription=0&is_billing=0&business_field=0`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getPaymentMethodPbf = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/payment/options`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};


export const getShippingMethod = async (pbfId) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}get/shipping/method${pbfId ? `?pbf_id=${pbfId}` : ""
        }`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const fetchCheckoutCart = async (voucher_id) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}handle/cart/checkout`,
      method: "POST",
      data: {
        voucher_id: voucher_id,
      },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const fetchCheckoutCartNew = async (voucher_id) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}handle/cart/checkout-v2`,
      method: "POST",
      data: {
        voucher_id: voucher_id,
      },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const fetchCheckoutCartPbf = async (voucher_id) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/cart/checkout`,
      method: "POST",
      data: {},
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response?.data ?? err;
  }
};



export const OtpCheckout = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}checkout/sendotp`,
      method: "POST",
    };
    const res = await axios(config);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const verifyCheckoutOtp = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}checkout/verifyotp`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail.verify;
  } catch (err) {
    throw err;
  }
};

export const verifyCheckoutOtpNew = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      // url: `${process.env.REACT_APP_API_PURCHASE}checkout/verifyotp-new`,
      url: `${process.env.REACT_APP_API_PURCHASE}checkout/verifyotp-v2`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const fetchTransactionList = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}list/transaction`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};


export const fetchTransactionListPbf = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/transaction/list`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

// Cancels an invoice still waiting payment or approval (be-olin-pbf decides).
export const cancelTransactionPbf = async ({ invoice_uid }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/transaction/cancel`,
      method: "POST",
      data: { invoice_uid },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response?.data ?? err;
  }
};

// Marks an arrived invoice as completed.
export const completeTransactionPbf = async ({ invoice_uid }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/transaction/complete`,
      method: "POST",
      data: { invoice_uid },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response?.data ?? err;
  }
};

export const fetchPaymentDetail = async ({ invoice }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}payment/detail`,
      method: "POST",
      data: {
        invoice,
      },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};



export const fetchPaymentDetailPbf = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/payment/detail`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const paymentCheck = async ({ invoice }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}payment/check`,
      method: "POST",
      data: {
        invoice,
      },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const paymentCheckPbf = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/payment/check`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const fetchTransactionDetail = async ({ invoice }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}transaction/detail`,
      method: "POST",
      data: {
        invoice,
      },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const fetchTransactionDetailNew = async ({ invoice }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}transaction/detail-new`,
      method: "POST",
      data: {
        invoice,
      },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const fetchTransactionDetailNewPbf = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/transaction/detail`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getSpPrint = async ({ invNum }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PRODUCT}transaction/purchase/pdf `,
      method: "POST",
      responseType: "blob",

      data: {
        invoice_number: invNum,
      },
    };
    const res = await axios(config);
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};

export const getSpPrintPbf = async ({ invNum }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/transaction/print-sp `,
      method: "POST",
      responseType: "blob",

      data: {
        invoice_uid: invNum,
      },
    };
    const res = await axios(config);
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};

export const getPrintFakturPbf = async ({ invoice_uid }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/transaction/print-faktur`,
      method: "POST",
      responseType: "blob",
      data: {
        invoice_uid,
      },
    };
    const res = await axios(config);
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};

export const postTransactionDone = async ({ invoice }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}transaction/done`,
      method: "POST",
      data: {
        invoice,
      },
    };
    const res = await axios(config);
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};

export const postReorderTransaction = async ({ invoice }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}transaction/reorder`,
      method: "POST",
      data: {
        invoice,
      },
    };
    const res = await axios(config);
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};

export const deleteCart = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      // url: `${process.env.REACT_APP_API_PURCHASE}cart/delete-v2`,
      url: `${process.env.REACT_APP_API_PBF}pbf/cart/clear`,
      method: "POST",
      data: {}
    };
    const res = await axios(config);
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};


export const deleteCartItem = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      // url: `${process.env.REACT_APP_API_PURCHASE}cart/delete-v2`,
      url: `${process.env.REACT_APP_API_PBF}pbf/cart/remove`,
      method: "POST",
      data: body
    };
    const res = await axios(config);
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};


export const addComplain = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}handle/complaint`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};

export const fetchComplainPage = async ({ invoice }) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}add/complaint`,
      method: "POST",
      data: { invoice },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const uploadComplainMedia = async (files) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];

  try {
    const config = {
      headers: {
        Authorization: TokenAuth,
        "Authorization-ID": TokenAuthID,
        "Content-Type": "multipart/form-data",
      },
      url: `${process.env.REACT_APP_API_MASTER}upload/multiple`,
      method: "POST",
      data: { files: files, type: "public", datasource: "complaint" },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getProductList = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}search/product-v2`, // old API, before connected to backstage PBF menu
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getProductListPbf = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/products/list`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const searchKeywordProduct = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      // url: `${process.env.REACT_APP_API_PURCHASE}search/product-elastic`,
      url: `${process.env.REACT_APP_API_PBF}pbf/products/suggest`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getCreditCardPlan = async (total, code) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PURCHASE}payment/credit-card-plan?total_price=${total}&payment_code=${code}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getCreditCardPlanPbf = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/payment/credit-card-plan`,
      method: "POST",
      data: body
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getNotificationPurchase = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_ACCOUNT}pos/notifications`,
      method: "POST",
      data: {},
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const readNotificationPurchase = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_ACCOUNT}pos/read-notifications`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const submitPurchaseCheckoutPbf = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/transaction/checkout`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response?.data ?? err;
  }
};

export const getBannerPbf = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/banners`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getPopupPbf = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/popups`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getShippingPbf = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/cart/shipping-rates`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};


export const getBannerProductList = async (body) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token()}` },
      url: `${process.env.REACT_APP_API_PBF}pbf/banners/detail`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};
// Halaman verifikasi dokumen dibuka lewat QR di lembar faktur, oleh siapa pun
// yang memegang kertasnya — tidak ada sesi yang bisa dipakai, jadi tidak ada
// header Authorization di dua fungsi berikut.
export const verifyFakturPbf = async (invoiceUid) => {
  try {
    const config = {
      url: `${process.env.REACT_APP_API_PBF}pbf/public/faktur/${invoiceUid}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    // Halaman ini dibuka orang di luar jaringan kantor; kegagalan jaringan
    // tidak punya err.response sama sekali.
    throw err?.response?.data || err;
  }
};

export const verifyFakturPbfPdfUrl = (invoiceUid) =>
  `${process.env.REACT_APP_API_PBF}pbf/public/faktur/${invoiceUid}/pdf`;
